import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { InputField, SelectField } from "../../FormFields";
import { AuthContext } from "../../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  sectionDivider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(3),
  }
}));

export default function AddressForm(props) {

  const { user, socket } = useContext(AuthContext);
  const classes = useStyles();

  const [billingName, setBillingName] = useState(user.company.name);
  const [addressZipCode, setAddressZipCode] = useState(user.company.document);
  const [addressStreet, setAddressStreet] = useState(user.company.addressStreet);
  const [addressState, setAddressState] = useState(user.company.addressState);
  const [addressCity, setAddressCity] = useState(user.company.addressCity);

  const {
    formField: {
      firstName,
      address1,
      city,
      state,
      zipcode,
      country,
      paymentMethod,
      nameOnCard,
      cardNumber,
      expiryDate,
      cvv
    },
    setFieldValue,
    values
  } = props;

  useEffect(() => {
    setFieldValue("firstName", billingName)
    setFieldValue("zipcode", addressZipCode)
    setFieldValue("address2", addressStreet)
    setFieldValue("state", addressState)
    setFieldValue("city", addressCity)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const paymentMethodOptions = [
    { label: 'Cartão de Crédito', value: 'credit_card' },
    { label: 'PIX', value: 'pix' },
    { label: 'Boleto', value: 'boleto' }
  ];

  return (
    <React.Fragment>
    
      <Typography variant="h6" gutterBottom className={classes.sectionTitle}>
        1. Dados de Faturamento
      </Typography>
      <Grid container spacing={3}>

        <Grid item xs={6} sm={6}>
          <InputField name={firstName.name} label={firstName.label} fullWidth
            value={billingName}
            onChange={(e) => {
              setBillingName(e.target.value)
              setFieldValue("firstName", e.target.value)
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          <InputField
            name={zipcode.name}
            label={zipcode.label}
            fullWidth
            value={addressZipCode}
            onChange={(e) => {
              setAddressZipCode(e.target.value)
              setFieldValue("zipcode", e.target.value)
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <InputField
            name={address1.name}
            label={address1.label}
            fullWidth
            value={addressStreet}
            onChange={(e) => {
              setAddressStreet(e.target.value)
              setFieldValue("address2", e.target.value)
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          <InputField
            name={city.name}
            label={city.label}
            fullWidth
            value={addressCity}
            onChange={(e) => {
              setAddressCity(e.target.value)
              setFieldValue("city", e.target.value)
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          <InputField
            name={state.name}
            label={state.label}
            fullWidth
            value={addressState}
            onChange={(e) => {
              setAddressState(e.target.value)
              setFieldValue("state", e.target.value)
            }}
          />
        </Grid>

      </Grid>

      <div className={classes.sectionDivider}>
        <Typography variant="h6" gutterBottom className={classes.sectionTitle} style={{ marginTop: 0 }}>
          2. Método de Pagamento
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SelectField
              name={paymentMethod.name}
              label={paymentMethod.label}
              data={paymentMethodOptions}
              fullWidth
            />
          </Grid>

          {values.paymentMethod === 'credit_card' && (
            <>
              <Grid item xs={12}>
                <InputField
                  name={nameOnCard.name}
                  label={nameOnCard.label}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <InputField
                  name={cardNumber.name}
                  label={cardNumber.label}
                  placeholder="1234 5678 9012 3456"
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <InputField
                  name={expiryDate.name}
                  label={expiryDate.label}
                  placeholder="MM/YY"
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <InputField
                  name={cvv.name}
                  label={cvv.label}
                  placeholder="123"
                  fullWidth
                />
              </Grid>
            </>
          )}

          {values.paymentMethod === 'pix' && (
            <Grid item xs={12}>
              <Typography variant="body2" component="p" color="textSecondary">
                Após confirmar, você receberá um QR Code para escanear e confirmar o pagamento via PIX.
              </Typography>
            </Grid>
          )}

          {values.paymentMethod === 'boleto' && (
            <Grid item xs={12}>
              <Typography variant="body2" component="p" color="textSecondary">
                Após confirmar, você receberá um boleto para pagar. O acesso será liberado após a confirmação do pagamento.
              </Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </React.Fragment>
  );
}
